// extracted by mini-css-extract-plugin
var _1 = "ShippingCombineOrders__combineOrderCheckbox--D1HaY";
var _2 = "ShippingCombineOrders__combineOrderContainer--_7SYO";
var _3 = "ShippingCombineOrders__combineOrderInput--k0bbe";
var _4 = "ShippingCombineOrders__input--SHp0X Input__input--Dixy4 OfficeGeneral__input--Koyl1 OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _5 = "ShippingCombineOrders__orderIdLabel--teOjW";
export { _1 as "combineOrderCheckbox", _2 as "combineOrderContainer", _3 as "combineOrderInput", _4 as "input", _5 as "orderIdLabel" }
